import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import App from './App.vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use({
  install() {
    if (typeof document === 'undefined') {
      return;
    }

    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        const stylesheets = [
          '//fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap',
          '//cdn.lineicons.com/2.0/LineIcons.css',
        ];

        stylesheets.forEach((href) => {
          const link = document.createElement('link');

          link.href = href;
          link.rel = 'stylesheet';
          link.type = 'text/css';

          document.body.appendChild(link);
        });
      }, 300);
    });
  },
});
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
}).$mount('#app');
